import React from 'react'
import { Paper, Typography } from '@mui/material'
// import FlexBetween from './FlexBetween'
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function HeaderBox({ title, isOpen, setIsOpen }) {
    return (
        <Paper sx={{
            height: '30px', p: '5px', backgroundColor: '#a5d6a7',
            borderRadius: '5px', pl: 1, display: 'flex', alignItems: 'center'
        }}>
            <Typography > {title} </Typography>
            {/* <FlexBetween>
                <Typography >{title}</Typography>
                <IconButton onClick={()=>setIsOpen(!isOpen)}>
                    {isOpen?<ExpandMoreIcon/>: <ExpandLessIcon/>}
                </IconButton>
            </FlexBetween> */}
        </Paper>
    )
}

export default HeaderBox